const META_DEFINITIONS = {
  description: { attribute: 'name', value: 'description' },
  keywords: { attribute: 'name', value: 'keywords' },
  ogTitle: { attribute: 'property', value: 'og:title' },
  ogDescription: { attribute: 'property', value: 'og:description' },
  ogUrl: { attribute: 'property', value: 'og:url' },
  ogImage: { attribute: 'property', value: 'og:image' },
  twitterTitle: { attribute: 'name', value: 'twitter:title' },
  twitterDescription: { attribute: 'name', value: 'twitter:description' },
  twitterImage: { attribute: 'name', value: 'twitter:image' }
};

const CANONICAL_REL = 'canonical';

function findHeadElement(selector) {
  const elements = Array.from(document.head.querySelectorAll(selector));
  const [element, ...duplicates] = elements;

  duplicates.forEach((duplicate) => duplicate.remove());

  return element || null;
}

function ensureMetaTag(attribute, value) {
  const selector = `meta[${attribute}="${value}"]`;
  let element = findHeadElement(selector);
  const created = !element;

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, value);
    element.dataset.pageSeo = 'true';
    document.head.appendChild(element);
  }

  return { element, created };
}

function ensureCanonicalLink() {
  let element = findHeadElement(`link[rel="${CANONICAL_REL}"]`);
  const created = !element;

  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', CANONICAL_REL);
    element.dataset.pageSeo = 'true';
    document.head.appendChild(element);
  }

  return { element, created };
}

export function setPageSEO({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  twitterTitle,
  twitterDescription,
  twitterImage
}) {
  const previousTitle = document.title;
  const previousValues = [];

  if (title) {
    document.title = title;
  }

  Object.entries({
    description,
    keywords: Array.isArray(keywords) ? keywords.join(', ') : keywords,
    ogTitle,
    ogDescription,
    ogUrl: canonical,
    ogImage,
    twitterTitle,
    twitterDescription,
    twitterImage: twitterImage || ogImage
  }).forEach(([key, content]) => {
    if (!content) {
      return;
    }

    const definition = META_DEFINITIONS[key];
    const { element, created } = ensureMetaTag(definition.attribute, definition.value);

    previousValues.push({
      element,
      attribute: 'content',
      value: element.getAttribute('content'),
      created
    });

    element.setAttribute('content', content);
  });

  if (canonical) {
    const { element, created } = ensureCanonicalLink();

    previousValues.push({
      element,
      attribute: 'href',
      value: element.getAttribute('href'),
      created
    });

    element.setAttribute('href', canonical);
  }

  return () => {
    document.title = previousTitle;

    previousValues.forEach(({ element, attribute, value, created }) => {
      if (!element.isConnected) {
        return;
      }

      if (created) {
        element.remove();
        return;
      }

      if (value === null) {
        element.removeAttribute(attribute);
        return;
      }

      element.setAttribute(attribute, value);
    });
  };
}